import {all} from 'redux-saga/effects';

import {
  createFetchSagaLatest,
  createPostSagaLatest,
  createFetchSagaEvery
} from 'utils/sagas';

import {
  fetchBookingSet as fetchBookingSetAction,
  fetchBookingSets as fetchBookingSetsAction,
  fetchBookingSetsByTenant as fetchBookingSetsByTenantAction,
  fetchBookingSetsFinanceData as fetchBookingSetsFinanceDataAction,
  fetchVoidableInvoicesForBookingSet as fetchVoidableInvoicesForBookingSetAction,
  fetchBookingSetDepositFinanceData as fetchBookingSetDepositFinanceDataAction,
  fetchArrivalRoomChecks as fetchArrivalRoomChecksAction,
  fetchDepartureRoomChecks as fetchDepartureRoomChecksAction,
  fetchRoomOptionsForAddArrivalRoomCheck as fetchRoomOptionsForAddArrivalRoomCheckAction,
  fetchRoomOptionsForAddDepartureRoomCheck as fetchRoomOptionsForAddDepartureRoomCheckAction,
  fetchArrivalRoomCheck as fetchArrivalRoomCheckAction,
  fetchDepartureRoomCheck as fetchDepartureRoomCheckAction,
  fetchImageUrlAndFileName as fetchImageUrlAndFileNameAction,
  fetchDocumentFileName as fetchDocumentFileNameAction,
  fetchDepositTypes as fetchDepositTypesAction,
  fetchDepositSummaryStatuses as fetchDepositSummaryStatusesAction,
  fetchRoomChecksTimeline as fetchRoomChecksTimelineAction,
  createArrivalRoomCheck as createArrivalRoomCheckAction,
  createDepartureRoomCheck as createDepartureRoomCheckAction,
  verifyArrivalRoomCheckImageUpload as verifyArrivalRoomCheckImageUploadAction,
  removeArrivalRoomCheckImage as removeArrivalRoomCheckImageAction,
  verifyArrivalRoomCheckInventoryUpload as verifyArrivalRoomCheckInventoryUploadAction,
  removeArrivalRoomCheckInventory as removeArrivalRoomCheckInventoryAction,
  editArrivalRoomCheckExistingDamages as editArrivalRoomCheckExistingDamagesAction,
  editArrivalRoomCheckDescription as editArrivalRoomCheckDescriptionAction,
  editDepartureRoomCheckDescription as editDepartureRoomCheckDescriptionAction,
  editDepartureRoomCheckTotalDamageCharge as editDepartureRoomCheckTotalDamageChargeAction,
  editDepartureRoomCheckReleaseFullDeposit as editDepartureRoomCheckReleaseFullDepositAction,
  editDepartureRoomCheckStatus as editDepartureRoomCheckStatusAction,
  editDepositSummaryAmountToBeRetainedPaid as editDepositSummaryAmountToBeRetainedPaidAction,
  editDepositSummaryRefundToBeIssuedPaid as editDepositSummaryRefundToBeIssuedPaidAction,
  editDepositReleaseDueDate as editDepositReleaseDueDateAction,
  editDepositSummaryDepositType as editDepositSummaryDepositTypeAction,
  fetchDepositSummary as fetchDepositSummaryAction,
  verifyDepartureRoomCheckImageUpload as verifyDepartureRoomCheckImageUploadAction,
  removeDepartureRoomCheckImage as removeDepartureRoomCheckImageAction,
  removeDepartureRoomCheckInventory as removeDepartureRoomCheckInventoryAction,
  removeDepartureRoomCheckMaintenance as removeDepartureRoomCheckMaintenanceAction,
  verifyDepartureRoomCheckInventoryUpload as verifyDepartureRoomCheckInventoryUploadAction,
  verifyDepartureRoomCheckMaintenanceUpload as verifyDepartureRoomCheckMaintenanceUploadAction,
  editDepartureRoomCheckChargeFromDeposit as editDepartureRoomCheckChargeFromDepositAction,
  editArrivalRoomCheckStatus as editArrivalRoomCheckStatusAction
} from './';

import {
  fetchBookingSet,
  fetchBookingSets,
  fetchBookingSetsByTenant,
  fetchBookingSetsFinanceData,
  fetchVoidableInvoicesForBookingSet,
  fetchBookingSetDepositFinanceData,
  fetchArrivalRoomChecks,
  fetchDepartureRoomCheck,
  fetchDepartureRoomChecks,
  fetchRoomOptionsForAddArrivalRoomCheck,
  fetchRoomOptionsForAddDepartureRoomCheck,
  fetchImageUrlAndFileName,
  fetchDocumentFileName,
  fetchDepositTypes,
  fetchDepositSummaryStatuses,
  fetchRoomChecksTimeline,
  createArrivalRoomCheck,
  createDepartureRoomCheck,
  fetchArrivalRoomCheck,
  verifyArrivalRoomCheckImageUpload,
  removeArrivalRoomCheckImage,
  verifyArrivalRoomCheckInventoryUpload,
  removeArrivalRoomCheckInventory,
  editArrivalRoomCheckExistingDamages,
  editArrivalRoomCheckDescription,
  editDepartureRoomCheckDescription,
  editDepartureRoomCheckChargeFromDeposit,
  editDepartureRoomCheckTotalDamageCharge,
  editDepartureRoomCheckReleaseFullDeposit,
  editDepartureRoomCheckStatus,
  editDepositSummaryAmountToBeRetainedPaid,
  editDepositSummaryRefundToBeIssuedPaid,
  editDepositReleaseDueDate,
  editDepositSummaryDepositType,
  fetchDepositSummary,
  verifyDepartureRoomCheckImageUpload,
  removeDepartureRoomCheckImage,
  removeDepartureRoomCheckInventory,
  removeDepartureRoomCheckMaintenance,
  verifyDepartureRoomCheckInventoryUpload,
  verifyDepartureRoomCheckMaintenanceUpload,
  editArrivalRoomCheckStatus
} from 'sdk/bookingSets';

function* bookingSetsSaga() {
  yield all([
    createFetchSagaLatest(fetchBookingSetsAction, fetchBookingSets),
    createFetchSagaLatest(
      fetchBookingSetsByTenantAction,
      fetchBookingSetsByTenant
    ),
    createFetchSagaLatest(fetchBookingSetAction, fetchBookingSet),
    createFetchSagaLatest(
      fetchBookingSetsFinanceDataAction,
      fetchBookingSetsFinanceData
    ),
    createFetchSagaLatest(
      fetchVoidableInvoicesForBookingSetAction,
      fetchVoidableInvoicesForBookingSet
    ),
    createFetchSagaLatest(
      fetchBookingSetDepositFinanceDataAction,
      fetchBookingSetDepositFinanceData
    ),
    createFetchSagaLatest(fetchArrivalRoomChecksAction, fetchArrivalRoomChecks),
    createFetchSagaLatest(
      fetchDepartureRoomChecksAction,
      fetchDepartureRoomChecks
    ),
    createFetchSagaLatest(
      fetchRoomOptionsForAddArrivalRoomCheckAction,
      fetchRoomOptionsForAddArrivalRoomCheck
    ),
    createFetchSagaLatest(
      fetchRoomOptionsForAddDepartureRoomCheckAction,
      fetchRoomOptionsForAddDepartureRoomCheck
    ),
    createFetchSagaLatest(
      fetchDepositSummaryStatusesAction,
      fetchDepositSummaryStatuses
    ),
    createFetchSagaLatest(
      fetchRoomChecksTimelineAction,
      fetchRoomChecksTimeline
    ),
    createPostSagaLatest(createArrivalRoomCheckAction, createArrivalRoomCheck),
    createPostSagaLatest(
      verifyArrivalRoomCheckImageUploadAction,
      verifyArrivalRoomCheckImageUpload
    ),
    createPostSagaLatest(
      removeArrivalRoomCheckImageAction,
      removeArrivalRoomCheckImage
    ),
    createPostSagaLatest(
      verifyArrivalRoomCheckInventoryUploadAction,
      verifyArrivalRoomCheckInventoryUpload
    ),
    createPostSagaLatest(
      removeArrivalRoomCheckInventoryAction,
      removeArrivalRoomCheckInventory
    ),
    createFetchSagaLatest(fetchArrivalRoomCheckAction, fetchArrivalRoomCheck),
    createFetchSagaLatest(
      fetchDepartureRoomCheckAction,
      fetchDepartureRoomCheck
    ),
    createFetchSagaEvery(
      fetchImageUrlAndFileNameAction,
      fetchImageUrlAndFileName
    ),
    createFetchSagaEvery(fetchDocumentFileNameAction, fetchDocumentFileName),
    createFetchSagaLatest(fetchDepositTypesAction, fetchDepositTypes),
    createPostSagaLatest(
      editArrivalRoomCheckExistingDamagesAction,
      editArrivalRoomCheckExistingDamages
    ),
    createPostSagaLatest(
      createDepartureRoomCheckAction,
      createDepartureRoomCheck
    ),
    createPostSagaLatest(
      editArrivalRoomCheckDescriptionAction,
      editArrivalRoomCheckDescription
    ),
    createPostSagaLatest(
      editDepartureRoomCheckDescriptionAction,
      editDepartureRoomCheckDescription
    ),
    createPostSagaLatest(
      editDepartureRoomCheckTotalDamageChargeAction,
      editDepartureRoomCheckTotalDamageCharge
    ),
    createPostSagaLatest(
      editDepartureRoomCheckReleaseFullDepositAction,
      editDepartureRoomCheckReleaseFullDeposit
    ),
    createPostSagaLatest(
      editDepartureRoomCheckStatusAction,
      editDepartureRoomCheckStatus
    ),
    createPostSagaLatest(
      editDepositSummaryAmountToBeRetainedPaidAction,
      editDepositSummaryAmountToBeRetainedPaid
    ),
    createPostSagaLatest(
      editDepositSummaryRefundToBeIssuedPaidAction,
      editDepositSummaryRefundToBeIssuedPaid
    ),
    createPostSagaLatest(
      editDepositReleaseDueDateAction,
      editDepositReleaseDueDate
    ),
    createPostSagaLatest(
      editDepositSummaryDepositTypeAction,
      editDepositSummaryDepositType
    ),
    createFetchSagaLatest(fetchDepositSummaryAction, fetchDepositSummary),
    createPostSagaLatest(
      verifyDepartureRoomCheckImageUploadAction,
      verifyDepartureRoomCheckImageUpload
    ),
    createPostSagaLatest(
      removeDepartureRoomCheckImageAction,
      removeDepartureRoomCheckImage
    ),
    createPostSagaLatest(
      verifyDepartureRoomCheckInventoryUploadAction,
      verifyDepartureRoomCheckInventoryUpload
    ),
    createPostSagaLatest(
      removeDepartureRoomCheckInventoryAction,
      removeDepartureRoomCheckInventory
    ),
    createPostSagaLatest(
      verifyDepartureRoomCheckMaintenanceUploadAction,
      verifyDepartureRoomCheckMaintenanceUpload
    ),
    createPostSagaLatest(
      removeDepartureRoomCheckMaintenanceAction,
      removeDepartureRoomCheckMaintenance
    ),
    createPostSagaLatest(
      editDepartureRoomCheckChargeFromDepositAction,
      editDepartureRoomCheckChargeFromDeposit
    ),
    createPostSagaLatest(
      editArrivalRoomCheckStatusAction,
      editArrivalRoomCheckStatus
    )
  ]);
}

export default bookingSetsSaga;
